import { ProjectDetailsTab } from "@/data/models/ProjectDetailsTab";

export interface MoveOrReopenFabVisibilityInput {
  projectNotFound: boolean;
  isNewProject: boolean;
  selectedTab: ProjectDetailsTab;
  isReadOnlyMode: boolean;
  hasReopenProjectPhasesAccess: boolean;
  canFinaliseProjectInOffice: boolean;
  hasMoveProjectAccess: boolean;
  areAllAssignmentsClosed: boolean;
}

/**
 * Determines whether the project-level FAB should be shown on the client-data tab.
 *
 * For finished/read-only projects, the FAB is the reopen action.
 * For running projects, the FAB is the move-to-finished action.
 */
export function shouldShowMoveOrReopenProjectFab(
  input: MoveOrReopenFabVisibilityInput
): boolean {
  if (input.projectNotFound) {
    return false;
  }

  if (
    input.isNewProject ||
    input.selectedTab !== ProjectDetailsTab.CLIENT_DATA
  ) {
    return false;
  }

  return input.isReadOnlyMode
    ? input.hasReopenProjectPhasesAccess && input.canFinaliseProjectInOffice
    : input.hasMoveProjectAccess && input.areAllAssignmentsClosed;
}
